<!-- Resumen desktop: cada segmento abre su selector; la flecha abre el panel completo -->
<div class="ctx-switcher" [class.is-open]="panelOpen">
    <div class="ctx-seg ctx-seg-empresa"
         [attr.title]="contextoPos ? companySelected?.razonSocial + ' · RUC ' + companySelected?.ruc : null"
         [class.ctx-seg-static]="!canSelectCompany" role="button" tabindex="0"
         (click)="openSegment('empresa', $event)" (keydown.enter)="openSegment('empresa', $event)">
        <small>Empresa<ng-container *ngIf="contextoPos"> · {{companySelected?.ruc}}</ng-container></small>
        <span>{{companySelected?.razonSocial}}</span>
    </div>
    <div class="ctx-seg" role="button" tabindex="0"
         [attr.title]="contextoPos ? office?.nombre : null"
         (click)="openSegment('sede', $event)" (keydown.enter)="openSegment('sede', $event)">
        <small>Sede</small>
        <span>{{office?.nombre || '—'}}</span>
    </div>
    <div class="ctx-seg" role="button" tabindex="0"
         [attr.title]="contextoPos ? saleStation?.nombre : null"
         (click)="openSegment('estacion', $event)" (keydown.enter)="openSegment('estacion', $event)">
        <small>Estación</small>
        <span>{{saleStation?.nombre || '—'}}</span>
    </div>
    <div class="ctx-caret" role="button" tabindex="0" pTooltip="Contexto de venta" tooltipPosition="bottom"
         (click)="open($event)" (keydown.enter)="open($event)">
        <i class="pi pi-chevron-down"></i>
    </div>
</div>

<!-- un overlay por segmento: abrir uno nuevo no queda bloqueado por la
     animación de cierre del anterior (mismo click cierra y abre) -->
<p-popover #segPanelEmpresa styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate="content">
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-popover>
<p-popover #segPanelSede styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate="content">
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-popover>
<p-popover #segPanelEstacion styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate="content">
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-popover>

<ng-template #segList>
    <div class="ctx-seg-list">
        <small class="ctx-seg-list-title">{{segTitle}}</small>
        <div class="ctx-seg-loading" *ngIf="segMode === 'estacion' && loadingStations">
            <i class="pi pi-spin pi-spinner"></i> Cargando…
        </div>
        <button type="button" class="ctx-seg-option" *ngFor="let item of segOptions"
                [class.is-current]="isCurrentSegItem(item)" (click)="selectSegItem(item)">
            <span>{{segLabel(item)}}</span>
            <i class="pi pi-check" *ngIf="isCurrentSegItem(item)"></i>
        </button>
    </div>
</ng-template>

<!-- Chip compacto para móvil -->
<div class="ctx-chip" role="button" tabindex="0" (click)="open($event)" (keydown.enter)="open($event)">
    <span>{{office?.nombre || '—'}}<ng-container *ngIf="saleStation"> · {{saleStation?.nombre}}</ng-container></span>
    <i class="pi pi-chevron-down"></i>
</div>

<p-popover #panel styleClass="ctx-panel" (onHide)="onPanelHide()">
    <ng-template pTemplate="content">
        <div class="ctx-form">
            <ng-container *ngTemplateOutlet="ctxHeader"></ng-container>
            <ng-container *ngTemplateOutlet="ctxFields"></ng-container>
            <ng-container *ngTemplateOutlet="ctxActions"></ng-container>
        </div>
    </ng-template>
</p-popover>

<p-drawer [(visible)]="sheetVisible" position="bottom" styleClass="ctx-sheet" [blockScroll]="true" appendTo="body">
    <div class="ctx-form">
        <ng-container *ngTemplateOutlet="ctxHeader"></ng-container>
        <ng-container *ngTemplateOutlet="ctxFields"></ng-container>

        <div class="ctx-sec" *ngIf="printerVisible || whatsappVisible">
            <small class="ctx-sec-title">Dispositivos</small>
            <div class="ctx-dev" *ngIf="printerVisible">
                <i class="pi pi-print"></i>
                <span>Impresión</span>
                <span class="ctx-dev-status" [class.is-ok]="printerConnected" [class.is-off]="!printerConnected">
                    {{printerConnected ? 'Equipo conectado' : 'Sin equipos conectados'}}
                </span>
                <button type="button" class="ctx-dev-link" aria-label="Ver equipos de impresión" aria-haspopup="dialog"
                        (click)="close(); printerClick.emit()">Ver equipos</button>
            </div>
            <small class="ctx-dev-hint" *ngIf="printerVisible">
                Estado de impresión de la sede activa de {{marca}}: {{office?.nombre || office?.codigo || 'sin sede seleccionada'}}.
            </small>
            <div class="ctx-dev" *ngIf="whatsappVisible">
                <i class="pi pi-whatsapp"></i>
                <span>WhatsApp</span>
                <span class="ctx-dev-status" [class.is-ok]="whatsappConnected" [class.is-off]="!whatsappConnected">
                    {{whatsappConnected ? 'Sesión activa' : 'Sin sesión'}}
                </span>
                <a *ngIf="!whatsappConnected && whatsappRoute" [routerLink]="whatsappRoute" (click)="close()">Conectar</a>
            </div>
        </div>

        <div class="ctx-sec" *ngIf="shortcuts?.length">
            <small class="ctx-sec-title">Accesos directos</small>
            <div class="ctx-chips">
                <a class="ctx-qchip" *ngFor="let item of shortcuts" [routerLink]="item?.ruta" [queryParams]="item?.queryParams"
                   (click)="close()">
                    <i *ngIf="item?.icono" [class]="item.icono | iconoPrime"></i>
                    {{item?.nombre}}
                </a>
            </div>
        </div>

        <ng-container *ngTemplateOutlet="ctxActions"></ng-container>
    </div>
</p-drawer>

<ng-template #ctxHeader>
    <h5 class="ctx-title">Contexto de venta</h5>
    <p class="ctx-subtitle">Todo lo que registres se guardará aquí. Los cambios se aplican al instante.</p>
</ng-template>

<ng-template #ctxFields>
    <div class="ctx-field">
        <label>Empresa</label>
        <p-select *ngIf="canSelectCompany; else empresaFija"
                    dataKey="id" [options]="attachedCompanies" [(ngModel)]="empresaSel"
                    optionLabel="razonSocial" (onChange)="onEmpresaChangeConfirmado()"
                    appendTo="body" [style]="{'width':'100%'}"></p-select>
        <ng-template #empresaFija>
            <div class="ctx-static">{{empresaSel?.razonSocial}}</div>
        </ng-template>
        <small>Razón social que emite tus comprobantes.</small>
    </div>

    <div class="ctx-field">
        <label>Sede / Punto de venta</label>
        <p-select dataKey="id" [options]="offices" [(ngModel)]="officeSel"
                    optionLabel="nombre" (onChange)="onOfficeChangeConfirmado()"
                    appendTo="body" [style]="{'width':'100%'}"></p-select>
        <small>Local donde se realiza la venta.</small>
    </div>

    <div class="ctx-field">
        <label>Estación</label>
        <p-select dataKey="id" [options]="stations" [(ngModel)]="stationSel"
                    optionLabel="nombre" (onChange)="onStationChangeConfirmado()" [disabled]="loadingStations"
                    [placeholder]="loadingStations ? 'Cargando…' : 'Seleccione'"
                    appendTo="body" [style]="{'width':'100%'}"></p-select>
        <small>Caja o equipo desde el que vendes.</small>
    </div>

    <div class="ctx-notice" *ngIf="canSelectCompany">
        <i class="pi pi-info-circle"></i>
        <span>Al cambiar de empresa, la sede y la estación se ajustan a las asignadas.</span>
    </div>
</ng-template>

<ng-template #ctxActions>
    <div class="ctx-actions">
        <button pButton type="button" label="Listo" (click)="close()"></button>
    </div>
</ng-template>
